import { IOrderActivityLog } from "../../../../interfaces";
import ChangeAddressLog from "./ChangeAddressLog";
import ChangeNoteLog from "./ChangeNoteLog";
import ChangeCommentLog from "./ChangeCommentLog";
/**
 * This component is operation update action component for activity log
 * @param param0 activity log details
 */
const ChangeLogComponent = ({
  activityLog,
}: {
  activityLog: IOrderActivityLog;
}) => {
  switch (activityLog.field) {
    case "address":
      return (
        <ChangeAddressLog
          createdAt={activityLog.createdAt}
          value={activityLog.value}
          updatedBy={activityLog.updatedBy}
        />
      );
    case "note":
      return (
        <ChangeNoteLog
          createdAt={activityLog.createdAt}
          value={activityLog.value}
          updatedBy={activityLog.updatedBy}
        />
      );
    case "comment":
      return (
        <ChangeCommentLog
          createdAt={activityLog.createdAt}
          value={activityLog.value}
          updatedBy={activityLog.updatedBy}
        />
      );
    default:
      return <></>;
  }
};

export default ChangeLogComponent;
